export default function action (type, args) {
  args = args || {}
  return {
    type,
    ...args
  }
}
